// ETOLIE 14.09.2026: po otwarciu okna (<dialog>: koszyk, menu, szukajka, szybkie dodanie, zoom galerii, filmy, odbiór w punkcie)
// przeglądarka sama ustawia fokus na pierwszym przycisku, zwykle krzyżyku. Safari na iOS rysuje wtedy ramkę
// :focus-visible (globalna reguła motywu w base.css), choć klientka tylko dotknęła ekranu (Jarek: „paskuda”).
// Jedna wspólna poprawka zamiast łatek per okno: gdy okno otwarto dotykiem lub myszą, zdejmujemy ten automatyczny fokus;
// pola tekstowe zostawiamy (szukajka ma dostać klawiaturę), a po klawiaturze (Tab, Enter) fokus i ramka zostają, bo wtedy są potrzebne.
(() => {
  if (typeof HTMLDialogElement === 'undefined') return;
  let klawiatura = false;
  document.addEventListener('keydown', () => { klawiatura = true; }, true);
  document.addEventListener('pointerdown', () => { klawiatura = false; }, true);
  document.addEventListener('touchstart', () => { klawiatura = false; }, { capture: true, passive: true });

  const zdejmijFokus = (dialog) => {
    const el = document.activeElement;
    if (klawiatura || !el || el === dialog || !dialog.contains(el)) return;
    if (el.matches('input, textarea, select, [contenteditable]')) return;
    el.blur();
  };

  for (const nazwa of ['showModal', 'show']) {
    const oryginal = HTMLDialogElement.prototype[nazwa];
    if (typeof oryginal !== 'function') continue;
    HTMLDialogElement.prototype[nazwa] = function (...args) {
      const wynik = oryginal.apply(this, args);
      zdejmijFokus(this);
      return wynik;
    };
  }
})();
